/** Returns true if the response should be cached */
export function shouldCacheResponse(response, _a) {
    var cachePredicate = _a.cachePredicate;
    if (typeof cachePredicate === 'function') {
        return cachePredicate(response);
    }
    return isCachePredicateValid(response, cachePredicate);
}
export function isCachePredicateValid(response, _a) {
    var statusCheck = _a.statusCheck, containsHeaders = _a.containsHeaders, responseMatch = _a.responseMatch;
    if (statusCheck) {
        if (typeof statusCheck === 'function') {
            if (!statusCheck(response.status)) {
                return false;
            }
        }
        else {
            var start = statusCheck[0], end = statusCheck[1];
            if (response.status < start || //
                response.status > end) {
                return false;
            }
        }
    }
    if (containsHeaders) {
        for (var headerName in containsHeaders) {
            var value = containsHeaders[headerName];
            var header = response.headers[headerName];
            // At any case, if the header is not found, the predicate fails.
            if (!header) {
                return false;
            }
            switch (typeof value) {
                case 'string':
                    if (header != value) {
                        return false;
                    }
                    break;
                case 'function':
                    if (!value(header)) {
                        return false;
                    }
                    break;
            }
        }
    }
    if (responseMatch && !responseMatch(response)) {
        return false;
    }
    return true;
}
